export default __webpack_public_path__ + "static/media/IMG_5565.2372a84d.jpg";